import { render } from "./AssetView.vue?vue&type=template&id=2f00e338&ts=true"
import script from "./AssetView.vue?vue&type=script&lang=ts"
export * from "./AssetView.vue?vue&type=script&lang=ts"

import "@/assets/scss/asset-view-style.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__